import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import { useCatalogs } from '../../api/hooks';

export function GesellschaftSelect({ value, onChange, label = 'Gesellschaften', error, helperText }: {
  value: string[];
  onChange: (ids: string[]) => void;
  label?: string;
  error?: string;
  helperText?: string;
}) {
  const { data } = useCatalogs();
  const options = data?.gesellschaften ?? [];
  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      options={options}
      value={options.filter((o) => value.includes(o.id))}
      getOptionLabel={(o) => o.name}
      isOptionEqualToValue={(a, b) => a.id === b.id}
      onChange={(_, v) => onChange(v.map((x) => x.id))}
      renderOption={(props, option, { selected }) => {
        const { key, ...rest } = props as typeof props & { key: string };
        return (
          <li key={key} {...rest}>
            <Checkbox size="small" checked={selected} sx={{ mr: 1, p: 0.5 }} tabIndex={-1} />
            {option.name}
          </li>
        );
      }}
      renderInput={(params) => <TextField {...params} label={label} error={!!error} helperText={error ?? helperText} />}
    />
  );
}

export function useGesellschaftNames() {
  const { data } = useCatalogs();
  return (ids: string[]) => ids.map((id) => data?.gesellschaften.find((g) => g.id === id)?.name ?? 'Gesellschaft außerhalb Ihres Scopes').join(', ');
}
